import React from 'react';
import SparePartsFinderCheckboxListMultiSelectFilter from './SparePartsFinderCheckboxListMultiSelectFilter';
import SparePartsFinderCheckboxListSingleSelectFilter from './SparePartsFinderCheckboxListSingleSelectFilter';
import IndexTableFiltersPanelLabel from '../../index-table/IndexTableFiltersPanelLabel';
import IndexTableFiltersPanelChips from '../../index-table/IndexTableFiltersPanelChips';

export default class SparePartsFinderFilterPanel extends React.Component {

    constructor(props) {
        super(props);

        this.inputsRefs = [];
        this.getFilters().map((f, i) => this.inputsRefs[i] = React.createRef());
    }

    render() {
        var i = -1;
        const groups = this.getFilters().partition(3);
        return (
            <div className="filter-steps">
                <div className="index-table-filters-panel">
                    {this.renderFilterChips()}
                </div>
                {groups.map((group, index) => (
                    <div className="filter-steps-row">
                        {group.map(f => {
                            if (!this.canRenderGroup(groups, index)) {
                                return <React.Fragment/>
                            }
                            i++;

                            const Component = f.meta.type === 'Select' ? SparePartsFinderCheckboxListMultiSelectFilter : SparePartsFinderCheckboxListSingleSelectFilter;
                            return (
                                <Component {...this.getFilterProps(f, i)} />
                            )
                        })}
                    </div>
                ))}
            </div>
        )
    }

    getFilters = () => this.props.filters.filter(x => x.meta.slug !== 'Market');

    canRenderGroup(groups, index) {
        if (index === 0) {
            return true;
        }

        if (index === 1) {
            return groups[0].filter(x => !x.meta.disabled).every(x => x.selectedItems.length > 0);
        }
    }

    clear() {
        this.inputsRefs.forEach(x => x.current.onClearClick());
    }

    renderFilterChips = () => {
        var chips = _.flatten(this.getFilters().map((f, i) => {
            var selectedItems = f.items.filter(o => f.selectedValues.includes(o.value));
            var sourceTexts = f.items.map(x => x.text);
            var sorted = _.sortBy(selectedItems, item => sourceTexts.indexOf(item.text));

            var current = this.inputsRefs[i].current;
            return sorted.map(x => <IndexTableFiltersPanelLabel
                label={x.text}
                color={this.getFilterChipColor(i)}
                onRemove={() => {
                    if (current) {
                        current.onChange(x.value)
                    }
                }}/>
            )
        }))

        return (
            <IndexTableFiltersPanelChips
                chips={chips}
                handleClearButtonClick={this.handleClearButtonClick}
            />
        )
    }

    handleClearButtonClick = () => {
        const filters = this.inputsRefs.filter(x => x.current).map(x => ({
            ...x.current.props,
            model: x.current.clear()
        }))

        this.props.onFiltersChange(filters);
    }

    getFilterProps = (filter, i) => ({
        ...filter,
        onFilterChange: this.props.onFilterChange,
        ref: this.inputsRefs[i],
        previousFilter: this.getPreviousFilter(i)
    })

    getPreviousFilter(i) {
        if (i === 0) {
            return null;
        }
        let previousFilter = null;
        while (previousFilter === null) {
            previousFilter = this.getFilters()[i - 1];
            if (!previousFilter.meta.visible) {
                previousFilter = null;
                i = i - 1;
            }
        }
        return previousFilter;
    }

    getFilterChipColor = i => {
        return ['orange', 'blue', 'green', 'purple', 'dark-pink', 'dark-green'][i]
    }
}